// extracted by mini-css-extract-plugin
module.exports = {"titleHeader":"eg9NJ","titleFirstLine":"_3qilF","titleSecondLine":"_1APVR"};